export const ERROR_MESSAGE = 'There is an error. please try again';

export const SUCCESS_MESSAGES = {
  otpSent: 'OTP sent successfully',
  otpVerified: 'Verified successfully',
  subscribed: 'You are subscribed',
} as const;
